var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSaveChanges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.37 3.84-.01-.066C12.07 1.791 10.528.282 8.607.104a24.7 24.7 0 0 0-4.542 0C2.145.282.6 1.791.31 3.775l-.009.065a28.8 28.8 0 0 0 0 8.32l.01.066c.29 1.983 1.833 3.493 3.753 3.67a25 25 0 0 0 3.599.067 2.84 2.84 0 0 1-.661-1.83v-3.6c0-.765.298-1.485.84-2.026a2.85 2.85 0 0 1 2.028-.84h2.795a29 29 0 0 0-.296-3.826M4.836 11h-.667a.667.667 0 1 1 0-1.334h.667a.667.667 0 1 1 0 1.334M6.17 8.666h-2a.667.667 0 1 1 0-1.333h2a.667.667 0 1 1 0 1.333m2.334-2.333H4.168a.667.667 0 1 1 0-1.333h4.336a.667.667 0 1 1 0 1.333",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.137 10.662-1.8-1.8a.67.67 0 0 0-.471-.196h-3c-.499 0-.967.195-1.32.547A1.86 1.86 0 0 0 8 10.533v3.6c0 .499.194.967.546 1.32.353.352.822.547 1.32.547h3.6c.5 0 .968-.194 1.32-.547s.547-.821.547-1.32v-3a.67.67 0 0 0-.195-.47zm-1.305 3.504c0 .46-.388.833-.866.833h-2.6c-.479 0-.867-.373-.867-.833V12.5c0-.46.388-.834.867-.834h2.6c.479 0 .867.373.867.834z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.366 12.5h-1.4c-.257 0-.466.186-.466.416v.833c0 .23.209.417.466.417h1.4c.258 0 .467-.186.467-.417v-.833c0-.23-.21-.417-.467-.417",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSaveChanges);
export default __webpack_public_path__ + "static/media/ic_save_changes.683bdde0dab58c8546e3189bebe9a883.svg";
export { ForwardRef as ReactComponent };